/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Label_EmailInputs */

const en_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const es_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const de_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

const zh_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子邮件`)
};

const ar_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البريد الإلكتروني`)
};

const fr_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const vi_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const sw_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barua pepe`)
};

const th_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อีเมล`)
};

const bs_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const ja_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレス`)
};

const ko_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일`)
};

const pt_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const it_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const sv_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-post`)
};

const nl_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const da_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const nb_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-post`)
};

const fi_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sähköposti`)
};

const pl_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const ru_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Электронная почта`)
};

const tr_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta`)
};

const hi_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल`)
};

const id_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const ms_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mel`)
};

const cs_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const el_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const he_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דוא״ל`)
};

const af_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-pos`)
};

const hu_auth_label_email = /** @type {(inputs: Auth_Label_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Auth_Label_EmailInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const auth_label_email = /** @type {((inputs?: Auth_Label_EmailInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Label_EmailInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_label_email(inputs)
	if (locale === "de") return de_auth_label_email(inputs)
	if (locale === "zh") return zh_auth_label_email(inputs)
	if (locale === "ar") return ar_auth_label_email(inputs)
	if (locale === "fr") return fr_auth_label_email(inputs)
	if (locale === "vi") return vi_auth_label_email(inputs)
	if (locale === "sw") return sw_auth_label_email(inputs)
	if (locale === "th") return th_auth_label_email(inputs)
	if (locale === "bs") return bs_auth_label_email(inputs)
	if (locale === "ja") return ja_auth_label_email(inputs)
	if (locale === "ko") return ko_auth_label_email(inputs)
	if (locale === "pt") return pt_auth_label_email(inputs)
	if (locale === "it") return it_auth_label_email(inputs)
	if (locale === "sv") return sv_auth_label_email(inputs)
	if (locale === "nl") return nl_auth_label_email(inputs)
	if (locale === "da") return da_auth_label_email(inputs)
	if (locale === "nb") return nb_auth_label_email(inputs)
	if (locale === "fi") return fi_auth_label_email(inputs)
	if (locale === "pl") return pl_auth_label_email(inputs)
	if (locale === "ru") return ru_auth_label_email(inputs)
	if (locale === "tr") return tr_auth_label_email(inputs)
	if (locale === "hi") return hi_auth_label_email(inputs)
	if (locale === "id") return id_auth_label_email(inputs)
	if (locale === "ms") return ms_auth_label_email(inputs)
	if (locale === "cs") return cs_auth_label_email(inputs)
	if (locale === "el") return el_auth_label_email(inputs)
	if (locale === "he") return he_auth_label_email(inputs)
	if (locale === "af") return af_auth_label_email(inputs)
	if (locale === "hu") return hu_auth_label_email(inputs)
	return en_auth_label_email(inputs)
});